<template>
  <div id="container" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <nyTit pathUrl="/yingyangcan" />
    <Tit/>
    <div class="content">
      <!-- 左 -->
      <div class="left">
        <div class="left_left1 flex_column">
          <div class="left_top flex_column">
            <div class="title">
              <span class="txt1">全国生姜产业现状</span>
            </div>
            <div class="ggtxt d1_pie">
              <div class="d1_pie_left flex_column">
                <div class="biaoti1">
                  <img
                    src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/qg.png"
                  />
                  <span>全国生姜种植面积</span>
                </div>
                <div class="biaoti2">（60871公顷）</div>
                <div class="ggtxt">
                  <leftPie />
                </div>
              </div>
              <div class="d1_pie_left flex_column">
                <div class="biaoti1">
                  <img
                    src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/qg.png"
                  />
                  <span>全国生姜产量约</span>
                </div>
                <div class="biaoti2">（2000万吨）</div>
                <div class="ggtxt"><leftPie1 /></div>
              </div>
            </div>
          </div>
          <div class="left_down flex_column">
            <div class="title">
              <span class="txt1">生姜电商市场热度</span>
            </div>
            <div class="ggtxt">
              <leftline />
            </div>
          </div>
        </div>
        <div class="left_left2 flex_column">
          <div class="left_left2_top flex_column">
            <div class="title">
              <span class="txt1">全国生姜主要品种供需关系</span>
            </div>
            <div class="ggtxt"><leftline2 /></div>
          </div>
          <div class="left_left2_down flex_column">
            <div class="title">
              <span class="txt1">近年小黄姜电商批发价格</span>
            </div>
            <div class="ggtxt flex_wrap">
              <leftline3 />
<!--              <div class="flex_wrap_pf"><leftPie2 /></div>-->
<!--              <div class="flex_wrap_pf"><leftPie3 /></div>-->
<!--              <div class="flex_wrap_pf"><leftPie4 /></div>-->
            </div>
          </div>
        </div>
      </div>

      <!-- 中 -->
      <div class="middle flex_column">
        <div class="middle_top flex_column">
          <div class="title">
            <span class="txt1">上蔡县黄姜产业现状</span>
          </div>
          <div class="middle_txt ggtxt flex_wrap">
            <div class="middle_txt_left flex_wrap_pf flex_column">
              <div
                class="nr ggtxt"
                v-for="(item, index) in state.left_data2"
                :key="index"
              >
                <img :src="item.img" />
                <span>{{ item.name }}</span>
                <span class="s_hs">{{ item.typ }}</span>
              </div>
            </div>
            <div class="middle_txt_right flex_column">
              <div class="hj_img">
                <img
                  src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/hj1.png"
                />
              </div>
              <div class="hj_bt">国家地理标志农产品“邵店黄姜”</div>
            </div>
          </div>
        </div>
        <div class="middle_down ggtxt flex_wrap">
          <div class="middle_down_left flex_column">
            <div class="title">
              <span class="txt1">上蔡县黄姜产业发展规划</span>
            </div>
            <div class="middle_down_left_info flex_column">
              <div
                class="nr ggtxt"
                v-for="(item, index) in state.left_data3"
                :key="index"
              >
                <img :src="item.img" />
                <span>{{ item.name }}</span>
                <span class="s_hs">{{ item.typ }}</span>
              </div>
            </div>
          </div>
          <div class="middle_down_right flex_wrap_pf flex_column">
            <div class="middle_down_right_bt">上蔡县黄姜全产业链场景展示</div>
            <div class="middle_down_right_nr ggtxt">
              <div
                class="shiping"
                v-for="(item, index) in state.videodata"
                :key="index"
                @click="videoClick(index, 1, item.type)"
              >
                <img :src="item.img" />
                <span class="shiping_nr">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右 -->
      <div class="right flex_wrap">
        <div class="right_l flex_wrap_pf flex_column">
          <div class="right_l_top flex_column">
            <div class="title">
              <span class="txt1">全国羊肚菌产业现状</span>
            </div>
            <div class="right_l_nr ggtxt flex_column">
              <div class="l_nr_txt ggtxt flex_wrap">
                <div
                  class="l_nr_txt_left flex_wrap_pf"
                  v-for="(item, index) in state.left_data1"
                  :key="index"
                >
                  <div class="bs_zt">
                    <img
                      src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/qg.png"
                    />
                    <span>{{ item.typ }}</span>
                  </div>

                  <div class="hs_zt">
                    <h5>{{ item.name }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right_l_mi ggtxt flex_column">
            <div class="title">
              <span class="txt1">全国羊肚菌售卖/采购热度走势</span>
            </div>
            <div class="ggtxt"><rightline /></div>
          </div>
          <div class="right_l_down ggtxt flex_column">
            <div class="title">
              <span class="txt1">全国羊肚菌电商批发均价</span>
            </div>
            <div class="ggtxt"><rightline1 /></div>
          </div>
        </div>
        <div class="right_r flex_wrap_pf flex_column">
          <div class="right_r_top flex_column">
            <div class="title">
              <span class="txt1">全国羊肚菌后市行情预测</span>
            </div>
            <div class="ggtxt flex_wrap right_r_top_txt">
              <div class="flex_wrap_pf"><rightPie /></div>
              <div class="flex_wrap_pf"><rightPie1 /></div>
              <div class="flex_wrap_pf"><rightPie2 /></div>
            </div>
          </div>
          <div class="right_r_mi flex_column">
            <div class="title">
              <span class="txt1">上蔡县羊肚菌产业发展规划</span>
            </div>
            <div class="right_r_mi_txt ggtxt">
              <div
                class="fz_nr"
                v-for="(item, index) in state.right_data1"
                :key="index"
              >
                <div class="fz_nr_top">
                  <img :src="item.img" />
                  <span>{{ item.typ }}</span>
                </div>
                <div class="fz_nr_down">
                  <span>{{ item.name }}</span>
                </div>
              </div>
              <div class="wl5"><span>未来五年</span></div>
            </div>
          </div>
          <div class="right_r_down flex_column ggtxt">
            <div class="middle_down_right_bt">上蔡县羊肚菌全产业链场景展示</div>
            <div class="middle_down_right_nr ggtxt">
              <div
                class="shiping"
                v-for="(item, index) in state.videodata1"
                :key="index"
                @click="videoClick(index, 2, item.type)"
              >
                <img :src="item.img" />
                <span class="shiping_nr">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <popBg v-if="state.popShow"
      :title="state.type == 1 ? state.videodata[state.curVideoIndex].name: state.videodata1[state.curVideoIndex].name "
           :type="type == 1? state.videodata[state.curVideoIndex].type : state.videodata1[state.curVideoIndex].type"
           :code="type == 1? state.videodata[state.curVideoIndex].code : state.videodata1[state.curVideoIndex].code"
      :popShow="state.popShow" @hiddlen="popHiddlen">
      <div style="width: 100%; height: 100%" v-if="state.videotype === 1">
        <vue3VideoPlay id="video" width="100%" height="100%" title="" :src="
            state.type == 1  ? state.videodata[state.curVideoIndex].options.src : state.videodata1[state.curVideoIndex].options.src"
          :type="state.type == 1 ? state.videodata[state.curVideoIndex].options.type: state.videodata1[state.curVideoIndex].options.type"
          :autoPlay="true"
        />
      </div>
      <div style="width: 100%; height: 100%" v-else>
        <iframe v-if="state.AccessToken!=''"
          :src="state.type == 1  ? (state.videodata[state.curVideoIndex].options.src+state.AccessToken) : (state.videodata1[state.curVideoIndex].options.src+state.AccessToken)"
          width="100%" height="100%" id="ysOpenDevice" allowfullscreen>
        </iframe>
      </div>
    </popBg>
  </div>
  <div class="footer">本产品由来村网提供技术支持</div>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";
import nyTit from "@/components/nyTit1.vue";
import leftPie from "../components/huangjiangyangdujun/leftPie.vue";
import leftPie1 from "../components/huangjiangyangdujun/leftPie1.vue";
import leftline from "../components/huangjiangyangdujun/leftline.vue";
import leftline2 from "../components/huangjiangyangdujun/leftline2.vue";
import leftline3 from "../components/huangjiangyangdujun/leftline3.vue";
import leftPie2 from "../components/huangjiangyangdujun/leftPie2.vue";
import leftPie3 from "../components/huangjiangyangdujun/leftPie3.vue";
import leftPie4 from "../components/huangjiangyangdujun/leftPie4.vue";
import rightline from "../components/huangjiangyangdujun/rightline.vue";
import rightline1 from "../components/huangjiangyangdujun/rightline1.vue";

import rightPie from "../components/huangjiangyangdujun/rightPie.vue";
import rightPie1 from "../components/huangjiangyangdujun/rightPie1.vue";
import rightPie2 from "../components/huangjiangyangdujun/rightPie2.vue";
import popBg from "../components/popBg.vue";
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";
import Tit from "@/components/Tit.vue";
import { useStore } from "vuex";

// const timer = ref(null);
const store = useStore();
const router = useRouter();
const mapRef = ref(null);
const state = reactive({
  videodata: [
    {
      name: "黄姜产品电商直播视频",
      type: 1, //1是使用VideoPlay播放2是直接嵌套播放
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/img/hjz.png",
      options: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/hjz.mp4", //视频源
        type: "video/mp4", //视频类型
      },
    },
    {
      name: "黄姜加工车间",
      type: 1, //1是使用VideoPlay播放2是直接嵌套播放
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/sjjiagongchejian.png",
      options: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/sjjiagongchejian.mp4", //视频源
        type: "video/mp4", //视频类型
      },
    },
    {
      name: "黄姜种植基地",
      type: 1, //1是使用VideoPlay播放2是直接嵌套播放
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/xhjjidi.png",
      options: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/xhjjidi.mp4", //视频源
        type: "video/mp4", //视频类型
      },
    },
    {
      name: "黄姜育苗基地",
      type: 1, //1是使用VideoPlay播放2是直接嵌套播放
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/hjyumiao.png",
      options: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/hjyumiao.mp4", //视频源
        type: "video/mp4", //视频类型
      },
    },
  ],
  videodata1: [
    {
      name: "羊肚菌直播间",
      type: 1, //1是使用VideoPlay播放2是直接嵌套播放
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/img/jt.png",
      options: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/jt.mp4", //视频源
        type: "video/mp4", //视频类型
      },
    },

    {
      name: "羊肚菌生产车间",
      type: 1, //1是使用VideoPlay播放2是直接嵌套播放
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/ydj1.png",
      options: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/ydj2.mp4", //视频源
        type: "video/mp4", //视频类型
      },
    },
    {
      name: "羊肚菌栽培基地",
      type:2,//1是使用VideoPlay播放2是直接嵌套播放
      img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/10-18/image/1-17.gif",
      // options: {
      //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/10-18/17.mp4", //视频源
      //   type: "video/mp4", //视频类型
      // },
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FA2454812/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
      code:"FA2454812"
    },
    {
      name: "羊肚菌育种基地",
      type: 1, //1是使用VideoPlay播放2是直接嵌套播放
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/ydjyz.png",
      options: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/huangjiangyangdujun/sp/ydjyz.mp4", //视频源
        type: "video/mp4", //视频类型
      },
    },
  ],
  left_data1: [
    {
      typ: "全国羊肚菌企业数量",
      name: "（2862家）",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/qg.png",
    },
    {
      typ: "全国羊肚菌栽培面积",
      name: "（44.73万亩）",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/qg.png",
    },
  ],
  right_data1: [
    {
      typ: "现有羊肚菌种植企业",
      name: "（11家）",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/qg.png",
    },
    {
      typ: "羊肚菌栽培面积",
      name: "（3000亩）",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/qg.png",
    },
    {
      typ: "种植面积",
      name: "（1200亩）",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/qg.png",
    },
    {
      typ: "全产业链产值达到",
      name: "（1亿元）",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/qg.png",
    },
  ],
  left_data2: [
    {
      typ: "邵店小黄姜",
      name: "主要种植品种：",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zy.png",
    },
    {
      typ: "15000亩",
      name: "种植面积：",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zy.png",
    },
    {
      typ: "30000吨",
      name: "总产量：",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zy.png",
    },
    {
      typ: "10%",
      name: "深加工占比：",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zy.png",
    },
  ],
  left_data3: [
    {
      typ: "20000亩",
      name: "种植面积达到",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zy.png",
    },
    {
      typ: "6个",
      name: "开发黄姜深加工产品",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zy.png",
    },
    {
      typ: "30%",
      name: "深加工占比达到",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zy.png",
    },
    {
      typ: "5亿元",
      name: "全产业链产值达到：",
      img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zy.png",
    },
  ],
  popShow: false,
  curVideoIndex: 0,
  isShow: false,
  startVal: 0, //数字结束
  videotype: 1,
  type: 1,
  AccessToken:""
});

// 地图底图
function videoClick(index1, type, types) {
  console.log(index1);
  state.popShow = true;
  state.curVideoIndex = index1;
  state.type = type;
  state.videotype = types;
}
function popHiddlen() {
  state.popShow = false;
}

// 在 onMounted 中初始化地图
onMounted(() => {
  store.commit('getToken')
  setTimeout(()=>{
    // console.log(store.state.AccessToken)
    state.AccessToken = store.state.AccessToken
  },1000)
});

onUnmounted(() => {});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 30px;
  position: fixed;
  bottom: 30px;
  left: 0;
  z-index: 10000;
  font-weight: bold;
}

body {
  background-size: cover;
  line-height: 1.15;
}

.mainBox {
  width: 100%;
  height: 100%;

  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/bj.jpg")
    no-repeat top center;
  background-size: 100% 100%;

  .content {
    top: 220px;
    left: 0;
    width: 100%;
    position: absolute;
    height: calc(100% - 310px);
    flex-flow: row;
    display: flex;
    //公共的向下布局
    .flex_column {
      display: flex;
      flex-direction: column;
    }
    .ggtxt {
      width: 100%;
      flex: 1;
    }
    .flex_wrap {
      display: flex;
    }
    .flex_wrap_pf {
      flex: 1;
      height: 100%;
    }
    //公共标题
    .title {
      width: 100%;
      height: 60px;
      padding-left: 50px;
      box-sizing: border-box;
      line-height: 60px;
      color: #fff;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/dbt.png")
        no-repeat;
      display: flex;
      span {
        display: block;
      }
      .txt1 {
        font-size: 30px;
        background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        font-weight: bold;
        padding: 0 10px;
      }
      .txt2 {
        color: #0287ba;
        margin-left: 20px;
        font-size: 22px;
        font-family: Arial, Helvetica, sans-serif;
      }
    }
    //公共布局

    .left {
      width: 2000px;
      height: 100%;
      margin-left: 100px;
      //border: 1px solid #fff;
      display: flex;

      .left_left1 {
        flex: 1;
        height: 100%;
        .left_top {
          width: 100%;
          flex: 1;
          .d1_pie {
            display: flex;
            height: 100%;
            .d1_pie_left {
              height: 100%;
              // border: 1px solid #fff;
              flex: 1;
              .biaoti1 {
                width: 100%;
                height: 42px;
                // border: 1px solid #fff;
                display: flex;
                margin-top: 40px;
                // justify-content: center;
                align-items: center;
                img {
                  width: 42px;
                  height: 42px;
                  margin-left: 40px;
                }
                span {
                  color: #fff;
                  font-size: 34px;
                  text-align: left;
                }
              }
              .biaoti2 {
                width: 100%;
                height: 42px;
                // border: 1px solid #fff;
                color: #fcd31f;
                font-size: 34px;
                text-align: left;
                text-indent: 2.5em;
                margin-top: 10px;
              }
            }
          }
        }
        .left_down {
          width: 100%;
          // flex: 1;
          height: 550px;
        }
      }
      .left_left2 {
        flex: 1;
        height: 100%;
        .left_left2_top {
          flex: 1;
        }
        .left_left2_down {
          width: 100%;
          height: 550px;
        }
      }
    }
    .middle {
      flex: 1;
      height: 100%;
      margin: 0 50px;
      padding-top: 50px;
      .title {
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/cbt.png")
          no-repeat;
      }
      .middle_top {
        width: 100%;
        height: 650px;
        // border: 1px solid #fff;
        .middle_txt {
          margin-top: 20px;
          .middle_txt_left {
            padding-left: 40px;
            padding-right: 60px;
            .nr {
              background: linear-gradient(
                to right,
                rgba(4, 53, 99, 0.5),
                rgba(4, 53, 99, 0.1)
              );
              margin: 20px 0;
              display: flex;

              align-items: center;
              img {
                width: 70px;
                height: 70px;
                margin-left: 30px;
              }
              span {
                display: block;
                width: 250px;
                color: #fff;
                font-size: 30px;
                margin-left: 40px;
                text-align: left;
              }
              .s_hs {
                display: block;
                color: #ffd15c;
                font-size: 50px;
                margin-left: 200px;
                text-align: left;
              }
            }
          }
          .middle_txt_right {
            width: 950px;
            height: 100%;
            display: flex;
            align-items: center;

            .hj_img {
              width: 100%;
              height: 428px;
              margin-top: 20px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .hj_bt {
              width: 100%;
              height: 96px;
              color: #fff;
              font-size: 30px;
              background: rgba(7, 72, 112, 0.7);
              text-align: center;
              line-height: 96px;
              letter-spacing: 20px;
            }
          }
        }
      }
      .middle_down {
        // border: 1px solid #fff;
        padding-top: 20px;
        .title {
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/dbt.png")
            no-repeat;
        }

        .middle_down_left {
          width: 1050px;
          height: 100%;
          .middle_down_left_info {
            width: 100%;
            flex: 1;
            padding-left: 40px;
            padding-right: 60px;
            .nr {
              background: linear-gradient(
                to right,
                rgba(4, 53, 99, 0.5),
                rgba(4, 53, 99, 0.1)
              );
              margin: 20px 0;
              display: flex;

              align-items: center;
              img {
                width: 70px;
                height: 70px;
                margin-left: 30px;
              }
              span {
                display: block;
                width: 280px;
                color: #fff;
                font-size: 30px;
                margin-left: 40px;
                text-align: left;
              }
              .s_hs {
                display: block;
                color: #ffd15c;
                font-size: 50px;
                margin-left: 200px;
                text-align: left;
              }
            }
          }
        }
        .middle_down_right {
          padding-left: 55px;
        }
      }
    }
    .middle_down_right_bt {
      width: 100%;
      height: 50px;
      color: #00beff;
      text-align: left;
      font-size: 28px;
      line-height: 50px;
      text-indent: 1em;
    }
    .middle_down_right_nr {
      display: flex;
      flex-wrap: wrap; /* 允许项目换行 */
      .shiping {
        width: 386px;
        height: 238px;
        // border: 1px solid #fff;
        margin: 20px 40px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/ydj.png")
          no-repeat top center;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          padding: 10px 10px;
        }
        .shiping_nr {
          width: 386px;
          height: 50px;

          background-color: rgba(10, 89, 127, 0.7);
          color: #fff;
          font-size: 30px;
          position: absolute;
          line-height: 50px;
          bottom: 0;
          left: 0;
          padding: 0 10px;
        }
      }
    }
    .right {
      //border: 1px solid #fff;
      width: 2000px;
      height: 100%;
      margin-right: 100px;
      .right_l {
        .right_l_top {
          width: 100%;
          height: 230px;
          .right_l_nr {
            margin-top: 30px;
            .l_nr_txt {
              display: flex;
              justify-content: center;
              align-items: center;
              .l_nr_txt_left {
                flex-direction: column;
                .bs_zt {
                  width: 100%;
                  height: 50%;
                  display: flex;
                  // justify-content: center;
                  align-items: center;
                  img {
                    width: 48px;
                    height: 48px;
                    margin-left: 40px;
                  }
                  span {
                    font-size: 34px;
                    color: #fff;
                    height: 48px;
                    padding-left: 20px;
                  }
                }
                .hs_zt {
                  width: 100%;
                  height: 50%;

                  h5 {
                    display: block;
                    width: 100%;
                    height: 48px;
                    font-size: 34px;
                    color: #ffdc44;
                    text-align: left;
                    text-indent: 3em;
                  }
                }
              }
            }
          }
        }
        .right_l_mi {
          margin: 10px 0;
        }
        .right_l_down {
          margin: 10px 0;
          .right_l_down_txt {
            margin-top: 30px;
          }
        }
      }
      .right_r {
        .right_r_top {
          width: 100%;
          height: 380px;
          // border: #00beff 1px solid;
          .right_r_top_txt {
            margin-top: 20px;
            margin-bottom: 20px;
          }
        }
        .right_r_mi {
          width: 100%;
          height: 360px;

          .right_r_mi_txt {
            // border: #00beff 1px solid;
            display: flex;
            flex-wrap: wrap;
            margin-top: 20px;
            position: relative;
            .wl5 {
              width: 368px;
              height: 65px;
              position: absolute;
              background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/jk1.png")
                no-repeat top center;
              background-size: 100% 100%;
              top: 29%;
              left: 23%;
              z-index: 99999;
              span {
                font-size: 28px;
                color: #fff;
              }
            }
            left: 0;
            .fz_nr {
              width: 50%;
              height: 50%;
              display: flex;
              flex-direction: column;
              .fz_nr_top {
                width: 100%;
                height: 50%;
                display: flex;
                align-items: center;
                img {
                  width: 48px;
                  height: 48px;
                  margin-left: 30px;
                }
                span {
                  color: #fff;
                  font-size: 34px;
                  margin-left: 30px;
                }
              }
              .fz_nr_down {
                width: 100%;
                height: 50%;
                display: flex;
                align-items: center;

                span {
                  color: #ffdc44;
                  font-size: 34px;
                  text-indent: 3em;
                  display: block;
                  margin-top: -30px;
                }
              }
            }
          }
        }
        .right_r_down {
          //border: #00beff 1px solid;
        }
      }
    }
  }
}

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
    animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
  }
}
</style>
